module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExtIt.3564d4e.woff";